module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/icons/underline.svg
 ** module id = 98
 ** module chunks = 0
 **/